import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { getAccountDetails } from "../../../services/fundraiserService";
import Loader from "../../common/Loader";

const BankAccountDetails = () => {
  const dispatch = useDispatch();
  const [bankDetails, setBankDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchBankDetails = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await dispatch(getAccountDetails())?.unwrap();
      console.log("Bank Account Details API Response:", response);
      if (response?.success === true) {
        console.log("Bank data from API:", response?.data?.bank);
        setBankDetails(response?.data?.bank || null);
      }
    } catch (error) {
      console.error("Error fetching bank details:", error);
      console.error("Error response:", error?.response?.data);
      // Silently handle error - don't show toast
    } finally {
      setIsLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchBankDetails();
  }, [fetchBankDetails]);

  const formatAccountNumber = (bankData) => {
    // Use maskedAccount if available, otherwise use last4 to create masked format
    if (bankData?.maskedAccount) {
      return bankData.maskedAccount;
    }
    if (bankData?.last4) {
      return `XXXX XXXX XXXX ${bankData.last4}`;
    }
    return "XXXX XXXX XXXX XXXX";
  };

  if (isLoading) {
    return (
      <div className="w-full bg-white rounded-xl shadow-lg mt-10">
        <div className="p-6">
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div
      className="w-full bg-white rounded-xl shadow-lg mt-10"
      style={{ boxShadow: '0px -6px 16px -6px rgba(0,0,0,0.08), 0px 6px 16px -6px rgba(0,0,0,0.08)' }}
    >
      <div className="p-6">
        <h2 className="text-[16px] font-[500] text-[#303030] font-poppins mb-4">Bank Account Details</h2>
        <hr className="border-t border-[#E9ECEF] mb-6" />
        
        {bankDetails && (bankDetails?.bankName || bankDetails?.maskedAccount || bankDetails?.last4) ? (
          <div className="flex flex-col gap-4">
            <div
              className="w-full rounded-lg border border-[#00ADEF] bg-[#EAF8FE] p-4 flex justify-between items-center"
            >
              <div>
                <div className="text-[16px] font-[600] font-poppins text-[#303030] mb-1">
                  {bankDetails?.bankName || "Bank Account"}
                </div>
                <div className="text-[14px] font-[400] font-poppins text-[#8C8C8C]">
                  {formatAccountNumber(bankDetails)}
                </div>
                {bankDetails?.accountHolderName && (
                  <div className="text-[12px] font-[400] font-poppins text-[#8C8C8C] mt-1">
                    {bankDetails.accountHolderName}
                  </div>
                )}
              </div>
              <span className="text-[#8C8C8C] font-poppins font-[400] text-[18px]">
                Primary
              </span>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-8">
            <p className="text-[14px] font-[400] text-[#8C8C8C] font-poppins">
              No bank account added yet
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BankAccountDetails; 